import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export default function MediaCard({ el }) {
  return (
    <Card sx={{ maxWidth: 345, minWidth: 345 }}>
      <CardMedia
        component="img"
        height="340"
        image={el.images[0].original}
        alt="sin foto"
      />
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {el.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {<div dangerouslySetInnerHTML={{ __html: el.details || "<em>sin detalles</em>"}}/>}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small">
          <a href={el.url} target="_blank" rel="noreferrer">
            VER MÁS
          </a>
        </Button>
      </CardActions>
    </Card>
  );
}
